import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { isNullOrEmpty, showMessageToast, showMessageToastCustom, translate } from '../../../../utils/util';
import ContainerService from '../../../../services/ContainerService';
import { Breadcrumbs, Input, Button, Table, Card } from '../../../../components/UI/ComponentsUI'
import { onValueChange, validateInputsRequired } from '../../../../utils/handleChangeHooks';
import SelectNew from '../../../../components/UI/SelectNew';
import { ENUMS, PERMISSIONS, VISIONS } from '../../../../utils/constants';
import { checkPermission, getVision } from '../../../../services/auth';
import useStateWithPromise from '../../../../utils/useEffectUpdate';

const ChangeStatusContainer = (props) => {
    const dataParams = props.history?.location?.state?.dataParams;
    const [containersUpdate, setContainersUpdate] = useState([]);
    const [containers, setContainers] = useState([]);
    const [selectItem, setSelectItem] = useState({});
    const [selectedUnloadLocation, setSelectedUnloadLocation] = useState({});
    const [filterChange, setFilterChange] = useStateWithPromise({
        name: dataParams?.name.toString() || "",

    });
    const [currentPage, setCurrentPage] = useState({ pageSize: 10, pageIndex: 0, sortField: "", sortOrder: 0 });
    useEffect(() => {
        // eslint-disable-next-line
        if ((props.containerStatus?.length ?? 0) === 0) props.getStatusContainer();
        if ((props.unloadLocations?.length ?? 0) === 0) props.getUnloadLocations();
    }, []);

    useEffect(() => {
        if (dataParams?.name) {
            searchContainer();
        }
    }, []);

    const onChangeFilter = (event) => {
        onValueChange(event, filterChange, setFilterChange);
    };


    const onChangeDock = (event) => {
        onValueChange(event, selectItem, setSelectItem);
    };

    const configColumnChange = () => {
        const cols = [
            {
                field: 'name',
                header: 'Nome Container',
                align: 'left',
                sortable: true
            },
            {
                field: 'statusDescription',
                header: 'Status Atual',
                align: 'left',
                sortable: true
            },
            {
                field: 'previousStatusDescription',
                header: 'Status Anterior',
                align: 'left',
                sortable: true
            }
        ];
        return cols;
    };

    const changeStatus = (container) => {
        if (getVision() !== VISIONS.Palomar && filterChange.status === ENUMS.eContainerStatus.ExitYard.value.toString()) {
            showMessageToast({ html: 'O campo Mvm é obrigatório.', classes: 'red' });
            return;
        }

        if (validateInputsRequired("getChange")) {
            const dataPut = {
                id: container.id,
                status: filterChange.status,
                mvmNumber: filterChange.mvmNumber,
                dock: filterChange.dock,
            }
            props.UpdateStatusContainer(dataPut, (response) => {
                console.log(response);
                containersUpdate.push(response);
                setContainersUpdate([...containersUpdate]);
                //setSelectItem({})
                setFilterChange({})
            })

        }
    }

    const revertStatus = (container) => {
        const dataPut = {
            id: container.id,
            status: container.previousStatus
        }
        props.UpdateStatusContainer(dataPut, (response) => {
            let containersUp = containersUpdate.filter(obj => obj.id !== response.id);
            containersUp.push(response);
            setContainersUpdate([...containersUp]);
            // setSelectItem({})
            setFilterChange({})
        })
    }

    const redirectStorageContainer = (item) => {

        props.history.push({
            state: {
                dataParams: item,
            },
            pathname: './container'
        });
    }

    const redirectSpawingContainer = (item) => {
        if (selectItem.unloadLocationId !== item.unloadLocationId) {
            item.unloadLocationId = selectItem.unloadLocationId;
        }
        props.history.push({
            state: {
                dataParams: item,
            },
            pathname: '../spawing/container'
        });
    }

    const configColumn = () => {
        const cols = [
            {
                field: 'name',
                header: 'Nome Container',
                align: 'left',
                sortable: true
            },
            {
                field: 'containerSizeName',
                header: 'Tamanho',
                align: 'left',
            },
            {
                field: 'statusDescription',
                header: 'Status Container',
                align: 'center',
                sortable: true
            },
            {
                field: 'location',
                header: 'Posição',
                align: 'center',
                sortable: true
            },
        ];
        return cols;
    };

    useEffect(() => {
        onSearch(false);
        // eslint-disable-next-line
    }, [currentPage]);

    const onSearch = () => {
        props.getPagedList({
            //status: [3,4,5,6,7,8], //“Todos os estados dentro da Planta” 
            sortField: currentPage.sortField,
            sortOrder: currentPage.sortOrder,
            PageSize: currentPage.pageSize,
            PageIndex: currentPage.pageIndex
        });
    }

    useEffect(() => {
        setContainers(props.containers?.items || []);
        // eslint-disable-next-line
    }, [props?.containers?.items]);


    const GetPermissionsChangeStatus = () => {
        let changeStatus = false;
        if (filterChange.status) {
            switch (parseInt(filterChange.status)) {
                case ENUMS.eContainerStatus.Transport.value:
                    changeStatus = checkPermission(PERMISSIONS.Warehouse_Container.ChangeStatus.Transport);
                    break;
                case ENUMS.eContainerStatus.InPort.value:
                    changeStatus = checkPermission(PERMISSIONS.Warehouse_Container.ChangeStatus.InPort);
                    break;
                case ENUMS.eContainerStatus.Released.value:
                    changeStatus = checkPermission(PERMISSIONS.Warehouse_Container.ChangeStatus.Released);
                    break;
                case ENUMS.eContainerStatus.InPlant.value:
                    changeStatus = checkPermission(PERMISSIONS.Warehouse_Container.ChangeStatus.InPlant);
                    break;
                case ENUMS.eContainerStatus.InYard.value:
                    changeStatus = checkPermission(PERMISSIONS.Warehouse_Container.ChangeStatus.InYard);
                    break;
                case ENUMS.eContainerStatus.DockTransit.value:
                    changeStatus = checkPermission(PERMISSIONS.Warehouse_Container.ChangeStatus.DockTransit);
                    break;
                case ENUMS.eContainerStatus.InDock.value:
                    changeStatus = checkPermission(PERMISSIONS.Warehouse_Container.ChangeStatus.DockTransit);
                    break;
                case ENUMS.eContainerStatus.Unloaded.value:
                    changeStatus = checkPermission(PERMISSIONS.Warehouse_Container.ChangeStatus.Unloaded);
                    break;
                case ENUMS.eContainerStatus.ReturnToYard.value:
                    changeStatus = checkPermission(PERMISSIONS.Warehouse_Container.ChangeStatus.ReturnToYard);
                    break;
                case ENUMS.eContainerStatus.ExitYard.value:
                    changeStatus = checkPermission(PERMISSIONS.Warehouse_Container.ChangeStatus.ExitYard);
                    break;
                case ENUMS.eContainerStatus.Exit.value:
                    changeStatus = checkPermission(PERMISSIONS.Warehouse_Container.ChangeStatus.Exit);
                    break;
                case ENUMS.eContainerStatus.ReturnToPort.value:
                    changeStatus = checkPermission(PERMISSIONS.Warehouse_Container.ChangeStatus.ReturnToPort);
                    break;
                default:
                    break;
            }
        }
        return changeStatus;

    }

    const searchContainer = () => {
        if (validateInputsRequired('getChange')) {
            props.getContainer(filterChange, (response) => {
                if (response) {
                    setSelectItem(response)
                }
            })
        }
    }
    return (
        <div>
            <Breadcrumbs
                title={{ icon: "mdi mdi-view-dashboard-outline", label: translate('container:storage:menu.change-status-container') }} />
            <div className="container-fluid" style={{ marginTop: '30px' }}>
                <div className="container" style={{ marginTop: '0px', }}>
                    <Card>
                        <div id="getChange" className="col s12">
                            <div className="row" style={{ padding: '10px' }}>
                                <div className="input-field no-padding col s6">
                                    <Input
                                        id="name"
                                        name='name'
                                        label="Num. Container / MVM ou Viagem"
                                        required={isNullOrEmpty(filterChange?.mvmNumber) && isNullOrEmpty(filterChange?.lotNumber)}
                                        type="text"
                                        value={filterChange?.name || ''}
                                        onChange={onChangeFilter}
                                    />
                                </div>
                                <div className="input-field no-padding col s5">
                                    <Input
                                        id="lotNumber"
                                        name='lotNumber'
                                        maxLength="11"
                                        label="Num. Lote"
                                        required={isNullOrEmpty(filterChange?.name)}
                                        type="text"
                                        value={filterChange?.lotNumber || ''}
                                        onChange={onChangeFilter}
                                    />
                                </div>
                                {
                                    selectItem?.id > 0 &&
                                    <div className="input-field no-padding col s12">
                                        <SelectNew
                                            id="status"
                                            name="status"
                                            required
                                            value={filterChange?.status || ''}
                                            change={onChangeFilter}
                                            placeHolder={translate('choose-one-option', 'general')}
                                            label="Status"
                                            data={props.containerStatus?.map((x) => ({ id: x.id, text: x.description }))}
                                        />
                                    </div>
                                }
                                {

                                    (filterChange?.status === ENUMS.eContainerStatus.DockTransit.value.toString() ||
                                        filterChange?.status === ENUMS.eContainerStatus.InDock.value.toString()

                                    )
                                    &&
                                    <div className="input-field no-padding col s12">
                                        <SelectNew
                                            id="unloadLocationId"
                                            name="unloadLocationId"
                                            required
                                            value={selectItem?.unloadLocationId || ''}
                                            change={onChangeDock}
                                            placeHolder={translate('choose-one-option', 'general')}
                                            label="Doca"
                                            data={props.unloadLocations?.map((x) => ({ id: x.id, text: `${x.dock} - ${x.description}` }))}
                                        />
                                    </div>
                                }
                            </div>
                        </div>
                        <div className="row" style={{ paddingTop: '5px' }}>
                            <Button full="true" text="Buscar" onClick={() => {
                                searchContainer();
                            }}
                            />
                        </div>

                        {
                            selectItem?.id > 0 &&
                            <>
                                <Table
                                    totalPages={0}
                                    disablePaged={true}
                                    col={[
                                        {
                                            field: 'name',
                                            header: 'Nome Container',
                                            align: 'left',
                                            sortable: true
                                        },
                                        {
                                            field: 'statusDescription',
                                            header: 'Status Atual',
                                            align: 'left',
                                            sortable: true
                                        }
                                    ]}
                                    data={[selectItem]}
                                    actions={[{
                                        function: (row) => (
                                            (GetPermissionsChangeStatus()) ? (
                                                <i
                                                    className="material-icons"
                                                    title="Alterar Status"
                                                    onClick={() => {
                                                        changeStatus(row);

                                                    }}
                                                    style={{ fontSize: "1.85rem", cursor: "pointer", color: "red" }} > check
                                                </i>) : null
                                        )
                                    }
                                    ]} />

                            </>

                        }

                    </Card>
                </div>
                {
                    containersUpdate.length > 0 &&
                    <Table
                        totalPages={0}
                        disablePaged={true}
                        col={configColumnChange()}
                        data={containersUpdate}
                        actions={[{
                            function: (row) => (
                                (GetPermissionsChangeStatus()) ? (
                                    <i
                                        className="material-icons"
                                        title="Voltar Status"
                                        onClick={() => {
                                            revertStatus(row);
                                        }}
                                        style={{ fontSize: "1.85rem", cursor: "pointer", color: "red" }} >arrow_back</i>) : null
                            )
                        },
                        {
                            function: (row) => (
                                (row.status === ENUMS.eContainerStatus.InYard.value || row.status === ENUMS.eContainerStatus.ReturnToYard.value) ? (
                                    <i
                                        className="mdi mdi-36px mdi-checkbox-marked-circle-outline gray-text"
                                        title="Armazenar Container"
                                        onClick={() => {
                                            redirectStorageContainer(row);
                                        }}
                                        style={{ fontSize: "1.85rem", cursor: "pointer", color: "green" }} >
                                    </i>
                                ) : null)
                        },
                        {
                            function: (row) => (
                                (row.status === ENUMS.eContainerStatus.DockTransit.value) ? (
                                    <i
                                        className="mdi mdi-36px mdi-dump-truck"
                                        title="Desovar Container"
                                        onClick={() => {
                                            redirectSpawingContainer(row);
                                        }}
                                        style={{ fontSize: "1.85rem", cursor: "pointer", color: "green" }} >
                                    </i>) : null
                            )
                        }
                        ]} />
                }
                {
                    !selectItem.id && <div id="items" className="container-fluid">
                        <Table
                            totalPages={props.list?.totalPages}
                            current={{ currentPage, setCurrentPage }}
                            col={configColumn()}
                            data={containers}
                            onClickRow={(evt) => {
                                filterChange.name = evt.name
                                setFilterChange({ ...filterChange }).then(() => {
                                    searchContainer();
                                })
                            }}
                        />
                    </div>
                }
            </div>

        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        usersFromElog: state.usersElogReducer.usersElog,
        user: state.userReducer.user,
        containers: state.containerReducer.containers,
        containerStatus: state.containerReducer.containerStatus,
        unloadLocations: state.containerReducer.unloadLocationList,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        UpdateStatusContainer: (data, callback) => {
            dispatch(ContainerService.UpdateStatusContainer(data, callback));
        },
        getContainer: (filter, callback) => {
            dispatch(ContainerService.getContainer(filter, callback));
        },
        getStatusContainer: (filter) => {
            dispatch(ContainerService.getStatusContainer(filter));
        },
        getUnloadLocations: () => {
            dispatch(ContainerService.getUnloadLocation(null));
        },
        getPagedList: (filter) => {
            dispatch(ContainerService.getContainerPaged(filter));
        },
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ChangeStatusContainer));
